let initialState = {
  authParams: null,
  global_dashboard_duration: null,
  global_dashboard_brands: null,
  global_dashboard_single_brands: null,
  global_category_id: null,
  redirected_screen_id: null,
  selected_theme_id: null,
};

const AuthParams = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PERSIST_AUTH_PARAMS":
      return {
        ...state,
        authParams: action.payload,
      };
    case "SET_DASHBOARD_GLOBAL_DURATION":
      return {
        ...state,
        global_dashboard_duration: action.payload,
      };
    case "SET_DASHBOARD_GLOBAL_BRANDS":
      return {
        ...state,
        global_dashboard_brands: action.payload,
      };
    case "SET_DASHBOARD_SINGLE_BRANDS":
      return {
        ...state,
        global_dashboard_single_brands: action.payload,
      };
    case "SET_GLOBAL_CATEGORY_ID":
      return {
        ...state,
        global_category_id: action.payload,
      };
    case "SET_REDIRECTED_SCREEN_ID":
      return {
        ...state,
        redirected_screen_id: action.payload,
      };
    case "SET_THEME_ID":
      let existingId = state.selected_theme_id;
      if (Array.isArray(action.payload)) {
        let isThemeExist = action.payload.find(
          (theme) => theme.theme_id == existingId
        );
        if (isThemeExist) {
          return {
            ...state,
          };
        } else {
          return {
            ...state,
            selected_theme_id: action.payload?.[0]?.theme_id || "000-000-001",
          };
        }
      } else {
        return {
          ...state,
          selected_theme_id: action.payload,
        };
      }
    default:
      return state;
  }
};

export default AuthParams;
